module.exports = function() {
  return new Worker(__webpack_public_path__ + "1f2c4500c6eb42de42b6.worker.js");
};